import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];

  connect() {
    this.updateButton();
  }

  updateButton() {
    const footer = this.element.closest('[role="footer"]');
    const button = footer
      ? footer.querySelector('button[type="submit"]')
      : null;

    if (button) {
      if (this.checkboxTarget.checked) {
        button.classList.remove("opacity-50", "pointer-events-none");
      } else {
        button.classList.add("opacity-50", "pointer-events-none");
      }
    }
  }
}
